module.exports = __webpack_public_path__ + "static/media/WhatwedoImg3.c6e01dd1.png";